<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Purchase record payment</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="lb_cont">
        <p>

            <span class="label">Purchase price: </span> <span class="label_txt">{{parentdata.data.currency_symbol}}{{parentdata.data.purchase_price.toFixed(2)}}</span>
        </p>
        <p>
                <span class="label">Amount paid: </span> <span class="label_txt">{{parentdata.data.currency_symbol}}{{(parentdata.data.purchase_price - parentdata.data.amount_due ).toFixed(2)}}</span>
        </p>
        <p>
            <span class="label">Amount due: </span> <span class="label_txt">{{parentdata.data.currency_symbol}}{{parentdata.data.amount_due.toFixed(2)}}</span>

        </p>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Payment amount</mat-label>
        <input [(ngModel)]="payment" matInput smDecimalOnly type="number" />

      </mat-form-field>
    </div>
   
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close >Cancel</button>
    <button
    style="color: #fff;"
      mat-flat-button
      color="accent"
      [disabled]="!payment || payment == 0"
      (click)="recordPayment()"
    >
      Record payment
    </button>
  </mat-dialog-actions>
  